import merge from 'lodash/merge';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LazyLoad from 'react-lazy-load';

const Image = ({
    className,
    role,
    alt,
    lazyLoad,
    lazyLoadOffsetVertical,
    onLoad,
    ...imgAttributes
}) => {
    const classes = classNames(className, 'Image', {'Image-loaded': !lazyLoad});
    const attrs = merge(
        {
            className: classes,
            role,
            alt,
            onLoad,
        },
        imgAttributes
    );

    if (lazyLoad) {
        return (
            <LazyLoad offsetVertical={lazyLoadOffsetVertical}>
                <img {...attrs} />
            </LazyLoad>
        );
    }

    return <img {...attrs} />;
};

Image.propTypes = {
    /** Additional class(es) to add to the component. */
    className: PropTypes.string,
    /** The role to set the image to. */
    role: PropTypes.string,
    /** Descriptive information about what is in the image. Do not use the words image, photo, or picture. */
    alt: PropTypes.string.isRequired,
    /** Whether to use lazy loading for this image. */
    lazyLoad: PropTypes.bool,
    /** The offset from the bottom of the screen at which point the image gets lazy loaded when the page is scrolled to. */
    lazyLoadOffsetVertical: PropTypes.number,
    /** Optional function to execute when the image is loaded. */
    onLoad: PropTypes.func,
};

Image.defaultProps = {
    lazyLoadOffsetVertical: 100,
};

export default Image;
